import React, { useState } from 'react';
import { Container, Grid, Card, Icon, Image, Menu, Button, Dimmer, Loader, Label } from 'semantic-ui-react';
import styled from 'styled-components';
import './App.css';
import axios from 'axios';
import { Auth0Client } from '@auth0/auth0-spa-js';
import { resolveConfig } from './config-util.js';

function Leads({ leads, user, setLoading, getAccessTokenSilently, className }) {
  const createApplication = async (lead) => {
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const config = resolveConfig();
      lead.emailAddress = config.application.lead_email;
      const response = await axios.post(config.application.imo_url, {
          agentId: "204",
          startedByUserId: "204",
          product: {
            jurisdiction: "CT",
            annuityType: "MYGA",
            productType: "MYGA_1",
            termSelection: "THREE_YEAR",
            typeOfOwnership: "NATURAL_PERSON"
          },
          owner: lead
      },{
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      console.log(response);

      if (response.status === 201) {
        lead.applicationId = response.data.applicationId;
        localStorage.setItem('leads', JSON.stringify(leads));

        // Initiate the SSO login flow with the proper redirect to the application url
        const client = new Auth0Client({
          domain: config.leads_sso.domain, // Replace with your Auth0 domain
          clientId: config.leads_sso.client_id, // Replace with your Auth0 client ID
          authorizationParams: {
            redirect_uri: config.leads_sso.redirect_uri,
            connection: config.leads_sso.connection
          }
        });
  
        client.loginWithRedirect();

        // TODO: Figure out how to open the new page and cause the login redirect in the new tab
        // window.open(`https://agent-dev.ilife3c.com/clientPipeline`, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      console.error("Error creating product:", error);
      // Optionally, handle errors with a message to the user
    } finally {
      setLoading(false);
    }
  };

  return (
    <center className={className}>
        <Container style={{ marginTop: '10%', maxWidth: '900px' }}>          
            <Grid centered stackable columns={2}>
              {leads.map((lead) => (
                <Grid.Column key={lead.id} style={{ padding: '1em 0' }}>
                  <Card style={{ padding: '1em', width: '500px' }}>                  
                    <Card.Content style={{ width: '100%'}}>
                      <Icon name="user circle" size="huge" style={{ float: 'right', marginTop: "15px" }} />
                      <Card.Header style={{ marginTop: "15px" }}>
                        {lead.firstName} {lead.lastName}
                      </Card.Header>
                      <Card.Meta>{lead.residenceAddress.city}, {lead.residenceAddress.state}</Card.Meta>
                      <Card.Description>
                        <p><strong>Email:</strong> {lead.emailAddress}</p>
                        <p><strong>Date of Birth:</strong> {lead.dateOfBirth} </p>
                        <p><strong>Phone:</strong> {lead.phoneNumber}</p>
                      </Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                      {
                        lead.applicationId == null ? 
                          <Button color='green' className='startButton' onClick={() => createApplication(lead)}><Icon name="plus circle" /> Start Application </Button> 
                          : <a href="https://agent-qa.ilife3c.com" target='_blank'><Button className='editButton'><Icon name="edit" /> Edit Application </Button></a>
                      }
                      {
                        lead.applicationId != null && (
                          <Label className='edit-label' attached='top'>
                            {lead.applicationId}
                          </Label>
                        ) 
                      }
                    </Card.Content>
                  </Card>
                </Grid.Column>
              ))}
            </Grid>
        </Container>
      </center>
  );
}

export default styled(Leads)`
  .startButton {
    color: white !important;
    background: #7daf42 !important;
    padding: 10px !important;
    border-radius: 5px !important;
  }

  .startButton:hover {
    background: #74930c !important;
    color: white !important;
  }

  .editButton {
    padding: 10px !important;
    border-radius: 5px !important;
  }

  .edit-label {
    background: #4e6c65 !important;
    color: white !important;
  }
`;
